module.exports = __webpack_public_path__ + "static/media/20.ceb5bcb0.jpg";